/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupplierWithoutData } from '../../models/supplier-without-data';

export interface AddSuppliersToOrgApiV2MembersOrgSuppliersPost$Params {
  org: string;
      body: Array<string>
}

export function addSuppliersToOrgApiV2MembersOrgSuppliersPost(http: HttpClient, rootUrl: string, params: AddSuppliersToOrgApiV2MembersOrgSuppliersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupplierWithoutData>>> {
  const rb = new RequestBuilder(rootUrl, addSuppliersToOrgApiV2MembersOrgSuppliersPost.PATH, 'post');
  if (params) {
    rb.path('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SupplierWithoutData>>;
    })
  );
}

addSuppliersToOrgApiV2MembersOrgSuppliersPost.PATH = '/api/v2/members/{org}/suppliers';
